export const SPEECH_TO_TEXT_CONFIG = {
  POSITIVE_SPEECH_THRESHOLD: 0.9, // Higher threshold to reduce background noise pickup
  NEGATIVE_SPEECH_THRESHOLD: 0.5, // Higher threshold to avoid false speech detection
  REDEMPTION_MS: 2500,
  MIN_SPEECH_MS: 500, // Require 500ms of speech before processing (filters out short noise bursts)

  // Streaming mode: Enable real-time transcription with Azure Speech Service
  ENABLE_STREAMING: true, // Set to true for real-time word-by-word transcription
};

// Audio Service Configuration
export const AUDIO_SERVICE_CONFIG = {
  SAMPLE_RATE: 24000,
  CHANNEL_COUNT: 1,
  FFT_SIZE: 2048,
  SMOOTHING_TIME_CONSTANT: 0.8,
  MIN_DECIBELS: -90,
  MAX_DECIBELS: -10,
  NORMALIZATION_FACTOR: 255,
} as const;

// Media Device Error Types
export const MEDIA_ERROR_TYPES = {
  NOT_FOUND: ["NotFoundError", "DevicesNotFoundError"] as string[],
  NOT_ALLOWED: ["NotAllowedError", "PermissionDeniedError"] as string[],
  NOT_READABLE: ["NotReadableError", "TrackStartError"] as string[],
  OVERCONSTRAINED: [
    "OverconstrainedError",
    "ConstraintNotSatisfiedError",
  ] as string[],
};

// Media Device Error Messages
export const MEDIA_ERROR_MESSAGES = {
  NOT_FOUND: "No microphone found. Please connect a microphone and try again.",
  NOT_ALLOWED:
    "Microphone access denied. Please allow microphone access in your browser settings.",
  NOT_READABLE: "Microphone is already in use by another application.",
  OVERCONSTRAINED: "Your microphone does not support the required settings.",
  DEFAULT: "Failed to access microphone for audio levels",
} as const;

// Microphone Configuration for Speech-to-Text
export const MICROPHONE_CONSTRAINTS = {
  ECHO_CANCELLATION: true,
  NOISE_SUPPRESSION: true,
  AUTO_GAIN_CONTROL: true,
  SAMPLE_RATE: 16000,
  CHANNEL_COUNT: 1,
  // Advanced constraints for better noise handling
  ADVANCED: {
    echoCancellation: { exact: true },
    noiseSuppression: { exact: true },
    autoGainControl: { exact: true },
  },
} as const;

// Speech-to-Text Error Messages
export const SPEECH_TO_TEXT_ERROR_MESSAGES = {
  NOT_FOUND: "No microphone found. Please connect a microphone and try again.",
  NOT_ALLOWED:
    "Microphone access denied. Please allow microphone access in your browser settings.",
  PERMISSION_REQUIRED:
    "Microphone permission required. Please check your browser settings.",
  RECORDING_FAILED: "Failed to start recording",
  ACCESS_FAILED: "Failed to access microphone",
} as const;

// VAD (Voice Activity Detection) Audio Processing Configuration
export const VAD_AUDIO_CONFIG = {
  SAMPLE_RATE: 16000,
  CHANNEL_COUNT: 1,
  BUFFER_SIZE: 4096,
  BACKEND_INIT_DELAY_MS: 0, // No delay needed - backend handles race conditions
  AUDIO_FRAME_LOG_INTERVAL: 50, // Log every N frames for monitoring
} as const;

// PCM16 Audio Conversion Constants
export const PCM16_CONVERSION = {
  MIN_VALUE: -1,
  MAX_VALUE: 1,
  NEGATIVE_MULTIPLIER: 0x8000, // 32768
  POSITIVE_MULTIPLIER: 0x7fff, // 32767
} as const;
